import React, { useState } from 'react';
import Sidebar from '../SideBar';
import MeetingRoom from './MeetingRoom';

function MeetingLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="app">
      <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      <div className="main-content">
        <MeetingRoom />
      </div>
    </div>
  );
}

export default MeetingLayout;